// Popular slider
new Splide( '#logo',{
    //padding: '2rem',
    trimSpace: false,
    perPage: 5,
    perMove: 1,
    pagination: false,
    arrows: false,
    gap: '6rem',
    //autoplay: 'playing',
    drag   : 'free',
    type: 'loop',
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',
    autoScroll: {
        speed: 3,
        pauseOnHover: false,
    },

    breakpoints: {
        1400: {
            perPage: 5,
        },
        1200: {
            perPage: 4,
            gap: '3rem',
        },
        580: {
            perPage: 2,
            gap: '2rem',
        },
    },

    classes: {
    },
} ).mount(window.splide.Extensions);



